import { render, staticRenderFns } from "./ProductTierCustomerGroups.vue?vue&type=template&id=59a6bb84&"
import script from "./ProductTierCustomerGroups.vue?vue&type=script&lang=ts&"
export * from "./ProductTierCustomerGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports